import { Link } from "react-router-dom";
import { Send, Loader2 } from "lucide-react";
import { useContactForm } from "@/hooks/useContactForm";

const inputCls =
    "w-full border border-white/15 bg-white/5 px-4 py-3.5 text-sm text-white placeholder-white/35 outline-none transition-colors duration-300 focus:border-tl-orange";

const FIELDS = [
    { name: "nome", label: "Nome e Cognome *", type: "text", required: true, placeholder: "Mario Rossi" },
    { name: "azienda", label: "Azienda", type: "text", placeholder: "Nome azienda" },
    { name: "email", label: "Email *", type: "email", required: true, placeholder: "nome@azienda.it" },
    { name: "telefono", label: "Telefono", type: "tel", placeholder: "+39 ..." },
];

const Field = ({ name, label, value, onChange, textarea, ...rest }) => (
    <div>
        <label htmlFor={`cf-${name}`} className="mb-2 block text-xs uppercase tracking-[0.15em] text-white/60">
            {label}
        </label>
        {textarea ? (
            <textarea
                id={`cf-${name}`}
                data-testid={`contact-form-input-${name}`}
                value={value}
                onChange={onChange}
                className={`${inputCls} resize-y`}
                {...rest}
            />
        ) : (
            <input
                id={`cf-${name}`}
                data-testid={`contact-form-input-${name}`}
                value={value}
                onChange={onChange}
                className={inputCls}
                {...rest}
            />
        )}
    </div>
);

const PrivacyCheckbox = ({ checked, onChange }) => (
    <label htmlFor="cf-privacy" className="mt-5 flex cursor-pointer items-start gap-3 text-xs leading-relaxed text-white/60">
        <input
            id="cf-privacy"
            data-testid="contact-form-checkbox-privacy"
            type="checkbox"
            required
            checked={checked}
            onChange={onChange}
            className="mt-0.5 h-4 w-4 shrink-0 cursor-pointer accent-tl-orange"
        />
        <span>
            Accetto il trattamento dei dati personali secondo la{" "}
            <Link to="/privacy-policy" className="text-tl-orange underline underline-offset-2 hover:text-tl-orangeHover">
                Privacy Policy
            </Link>
            .
        </span>
    </label>
);

const SubmitButton = ({ sending }) => (
    <button
        type="submit"
        data-testid="contact-form-submit-button"
        disabled={sending}
        className="mt-7 flex w-full items-center justify-center gap-3 bg-tl-orange px-8 py-4 font-mono-tl text-sm font-semibold uppercase tracking-[0.15em] text-tl-dark transition-colors duration-300 hover:bg-tl-orangeHover disabled:cursor-not-allowed disabled:opacity-60"
    >
        {sending ? (
            <>
                <Loader2 size={16} className="animate-spin" /> Invio in corso...
            </>
        ) : (
            <>
                Invia richiesta <Send size={15} />
            </>
        )}
    </button>
);

export const ContactForm = () => {
    const { form, sending, set, onSubmit } = useContactForm();
    return (
        <form data-testid="contact-form" onSubmit={onSubmit} className="border border-white/10 bg-tl-dark p-6 sm:p-9">
            <p className="font-mono-tl text-[11px] uppercase tracking-[0.3em] text-tl-orange">
                Modulo richiesta preventivo
            </p>
            <div className="mt-6 grid gap-5 sm:grid-cols-2">
                {FIELDS.map(({ name, ...f }) => (
                    <Field key={name} name={name} value={form[name]} onChange={set(name)} {...f} />
                ))}
            </div>
            <div className="mt-5">
                <Field
                    name="messaggio"
                    label="Messaggio *"
                    textarea
                    required
                    rows={5}
                    value={form.messaggio}
                    onChange={set("messaggio")}
                    placeholder="Descrivi il pezzo, lo stampo o la lavorazione di cui hai bisogno..."
                />
            </div>
            <PrivacyCheckbox checked={form.privacy} onChange={set("privacy")} />
            <input
                type="text"
                name="website"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                data-testid="contact-form-honeypot"
                value={form.website}
                onChange={set("website")}
                className="absolute -left-[9999px] h-0 w-0 opacity-0"
            />
            <SubmitButton sending={sending} />
        </form>
    );
};
